<template>
  <button @click="redirectLink(redirection, APP_URL)" class="button-outlined">
    {{ buttonText }}
  </button>
</template>

<script lang="ts">
import { toRefs } from "vue";
import { redirectLink } from "@/js/composable/redirectLink";

export default {
  name: "ButtonOutlined",
  props: {
    buttonText: {
      type: String,
      default: "Button",
    },
    buttonSize: {
      type: String,
      default: "",
    },
    redirection: {
      type: String,
      default: "#",
    },
  },
  setup(props: any) {
    const { redirection } = toRefs(props);

    return {
      APP_URL: import.meta.env.VITE_APP_URL,
      redirection,
      redirectLink,
    };
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.button-outlined {
  @apply w-fit rounded-full border border-primary-1 text-primary-1 hover:border-primary-2 hover:text-primary-2 disabled:border-disabled-1 disabled:text-disabled-text-1;
}
</style>
